/**
 * Reply templates used to live here: in localStorage, each operator's own, in
 * each browser. They are materials of the shared content library now (marked
 * "quick"); what is left in this file is the way out for the old ones — read
 * what this browser still holds, so it can be moved to the library once.
 */
export interface ReplySnippet {
  id: string;
  text: string;
}

const KEY = "inbox_reply_snippets_v1";
// Set once the operator has moved the old templates, or said they are not needed.
const SETTLED_KEY = "inbox_reply_snippets_moved_v1";

// What every browser showed before the operator edited the list.
const DEFAULTS: ReplySnippet[] = [
  { id: "seed-hi", text: "Здравствуйте! 👋" },
  { id: "seed-thanks", text: "Спасибо за ответ!" },
  { id: "seed-what", text: "Подскажите, что именно вас интересует?" },
];

/** The templates this browser still holds — none once they have been settled. */
export function legacySnippets(): ReplySnippet[] {
  try {
    if (localStorage.getItem(SETTLED_KEY) !== null) return [];
    const raw = localStorage.getItem(KEY);
    if (raw === null) return DEFAULTS;
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return DEFAULTS;
    return parsed.filter(
      (s): s is ReplySnippet =>
        s && typeof s.id === "string" && typeof s.text === "string" && s.text.trim() !== "",
    );
  } catch {
    return [];
  }
}

/**
 * The old templates are dealt with: do not offer them again in this browser.
 * They are left where they were — nothing reads them any more, and a browser's
 * copy is not ours to delete.
 */
export function settleLegacySnippets(): void {
  try {
    localStorage.setItem(SETTLED_KEY, "1");
  } catch {
    /* private mode — the offer will simply come back next time */
  }
}
